import { ref, reactive, computed } from 'vue'
import { localImages } from '../data/mock'
import { useI18n } from '../i18n'

const settings = ref({})
const loading = ref(true)

const bannerImages = reactive({
  home: '',
  products: '',
  productList: '',
  cases: '',
  news: '',
  about: '',
  contact: ''
})

const videos = reactive({
  home: ''
})

let loaded = false

const { locale } = useI18n()

const loadSettings = async (lang) => {
  if (!lang) {
    lang = locale.value || 'zh'
  }
  try {
    const response = await fetch(`/api/home/settings?lang=${lang}`)
    const result = await response.json()

    if (result.success) {
      settings.value = result.data
      Object.keys(result.data).forEach(key => {
        if (key.startsWith('banner.')) {
          const bannerKey = key.replace('banner.', '')
          if (bannerImages[bannerKey] !== undefined) {
            bannerImages[bannerKey] = result.data[key]
          }
        }
        if (key.startsWith('video.')) {
          const videoKey = key.replace('video.', '')
          if (videos[videoKey] !== undefined) {
            videos[videoKey] = result.data[key]
          }
        }
      })
      console.log('Loaded videos:', videos)
    }
  } catch (err) {
    console.error('Failed to load site settings:', err)
  } finally {
    loading.value = false
    loaded = true
  }
}

if (!loaded) {
  loadSettings(locale.value || 'zh')
}

export function useSiteSettings() {
  const getSetting = (key, defaultValue = '') => {
    return settings.value[key] || defaultValue
  }

  const getBannerImage = (key) => {
      return bannerImages[key] || localImages[key] || ''
    }

  return {
    settings,
    loading,
    loadSettings,
    getSetting,
    getBannerImage,
    videos
  }
}